import React from "react";

const NumberInput = ({
  value,
  onChange,
  placeholder = "Sayı girin...",
  label,
  required = false,
  error = false,
  errorMessage = "",
  min = 0,
  max,
  className = "",
  wrapperClassName = "",
  suffix = "",
  ...props
}) => {
  const handleChange = (e) => {
    const raw = e.target.value;

    // Boş bırakılabilsin (kullanıcı silip yeniden yazabilsin)
    if (raw === "" || raw === "-") {
      if (onChange) onChange("");
      return;
    }

    const numValue = Number(raw);
    if (!isNaN(numValue) && onChange) {
      onChange(numValue);
    }
  };

  // Blur'da boş bırakılmış - hata olarak kalacak, otomatik 0 yapmıyoruz
  const handleBlur = () => {
    // Boş bırakıldıysa hata devam etsin, kullanıcı düzeltmeli
  };

  return (
    <div className={`space-y-2 ${wrapperClassName}`}>
      {label && (
        <label className="block text-sm font-semibold text-gray-700">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          type="number"
          value={value ?? ""}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          className={`w-full px-4 py-3 bg-white border border-gray-200 rounded-2xl text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 shadow-sm hover:shadow-md ${
            error ? "border-red-300" : ""
          } ${suffix ? "pr-12" : ""} ${className}`}
          {...props}
        />
        {suffix && (
          <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-gray-500 shadow-sm">
            {suffix}
          </span>
        )}
      </div>
      {error && errorMessage && (
        <p className="text-red-500 text-xs mt-1">{errorMessage}</p>
      )}
    </div>
  );
};

export default NumberInput;
